export default __webpack_public_path__ + "static/media/eye.1cfae06c.svg";